module.exports = __webpack_public_path__ + "img/img-flow-1.8bbe4309.png";